<template>
  <v-dialog v-model="value" persistent scrollable max-width="70vw">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>{{ board?.board.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title class="mb-4 elevation-1"> New Card </v-card-title>
      <v-card-text>
        <v-form ref="cardForm" v-model="formValid" @input="handleEvent">
          <v-row class="py-4">
            <v-col cols="6" class="py-0">
              <v-text-field
                v-model="cardTitle"
                outlined
                clearable
                clear-icon="mdi-close-box"
                dense
                :rules="[rules.required]"
                label="Title"
                hide-details:
                @blur="isDirty = true"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                v-model="scansLocation"
                outlined
                clearable
                clear-icon="mdi-close-box"
                dense
                label="Scans location"
                hide-details:
                @blur="isDirty = true"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-autocomplete
                v-model="customer"
                :items="customers"
                outlined
                clearable
                clear-icon="mdi-close-box"
                dense
                hide-details:
                item-text="name"
                :rules="[rules.required]"
                label="Customer"
                :return-object="true"
                @change="isDirty = true"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-autocomplete
                v-model="list"
                :items="board.lists"
                outlined
                clearable
                clear-icon="mdi-close-box"
                dense
                hide-details:
                item-text="name"
                label="List"
                :rules="[rules.required]"
                :return-object="true"
                @change="isDirty = true"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-autocomplete
                v-model="labels"
                :items="board.labels"
                outlined
                clearable
                clear-icon="mdi-close-box"
                dense
                multiple
                hide-details:
                item-text="name"
                label="Labels"
                :return-object="true"
                @change="isDirty = true"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-autocomplete
                v-model="members"
                :items="board.members"
                outlined
                clearable
                clear-icon="mdi-close-box"
                dense
                multiple
                hide-details:
                item-text="fullName"
                label="Members"
                :return-object="true"
                @change="isDirty = true"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-autocomplete
                v-model="selectedProducts"
                :items="productTypes"
                outlined
                clearable
                clear-icon="mdi-close-box"
                dense
                multiple
                chips
                hide-details:
                item-text="title"
                label="Products"
                :return-object="true"
                @change="isDirty = true"
              >
                <template v-slot:selection="data">
                  <v-chip
                    class="ma-2"
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click:close="removeProduct(data.item)"
                  >
                    {{ data.item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="mt=0">
            <v-col cols="12" v-for="product of selectedProducts" :key="product.id">
              <v-card>
                <v-card-title>{{ product.title }}</v-card-title>
                <v-card-text>
                  <v-autocomplete
                    v-model="product.variants"
                    :items="getProductVariants(product.productTypeCode)"
                    outlined
                    clearable
                    clear-icon="mdi-close-box"
                    dense
                    multiple
                    chips
                    hide-details:
                    item-text="description"
                    label="Variants"
                    :return-object="true"
                    @change="isDirty = true"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        class="ma-2"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click:close="removeVariant(product, data.item)"
                      >
                        {{ data.item.description }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="!isDirty || !formValid"
          @click.native="createArtworkCard"
          >Create Card</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import TrelloApi from "@/api/admin/trello";
const server = process.env.VUE_APP_API_URL || "";

export default {
  props: {
    value: Boolean,
    board: Object,
  },
  components: {},
  async mounted() {},
  data() {
    return {
      formValid: false,
      isDirty: false,
      cardTitle: null,
      scansLocation: null,
      customer: null,
      list: null,
      labels: [],
      members: [],
      selectedProducts: [],
      products: [],
      productTypes: [],
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  computed: {
    artworkData() {
      return {
        title: this.cardTitle,
        scansLocation: this.scansLocation,
        customer: this.customer,
        labels: this.labels,
        list: this.list,
        members: this.members,
        products: this.selectedProducts,
      };
    },
    ...mapGetters({
      customers: "contacts/customers",
      productTypeVariants: "products/productTypeVariants",
    }),
  },
  async created() {
    this.productTypes = JSON.parse(
      JSON.stringify(this.$store.getters["products/productTypes"])
    );
  },
  methods: {
    createArtworkCard() {
      TrelloApi.createArtworkCard(this.artworkData).then((response) => {
        console.log(response.data);
        this.close();
      });
    },
    getProductVariants(productTypeCode) {
      return this.productTypeVariants.filter(
        (item) => item.productTypeCode === productTypeCode
      );
    },
    removeProduct(item) {
      const index = this.selectedProducts.findIndex(
        (v) => v.productTypeCode === item.productTypeCode
      );
      if (index >= 0) this.selectedProducts.splice(index, 1);
    },
    removeVariant(product, item) {
      const index = product.variants.findIndex(
        (v) => v.productTypeVariantCode === item.productTypeVariantCode
      );
      if (index >= 0) product.variants.splice(index, 1);
    },
    async handleEvent(evt) {
      console.log(evt);
      this.isDirty = true;
      this.$refs.cardForm?.validate();
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
